<template>
  <v-container>
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center mb-2">
        <h1>Trials By Enrollments</h1>
          <v-alert v-if="enrollments == false" color="info" icon="new_releases" :value="true">
            There are no enrollments.
          </v-alert>
      </v-flex>
      <v-flex xs10 sm11 md11 align-content-space-between mt-4 mb-4 ml-0 mr-0>
        <v-card class="info" v-for="(item, index) in enrollments" v-bind:key="item.enrollmentId" >
          <v-list class="listItems">
              <v-list-tile class="pb-2 pt-2 pl-2">
                <v-list-tile-avatar>
                  <v-icon left>bookmark_border</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.enrollmentName"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat ripple  :to="'/Trials/enrollments/' + item.enrollmentId">
                    <right-icon v-bind:color="item.active ? 'primary' : 'grey'" />
                  </v-btn>
                </v-list-tile-action>
                <v-menu bottom left v-if="userIsAuthenticated">
                  <v-btn icon slot="activator">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <template>
                          <app-edit-enrollment-dialog :enrollment="enrollment(index)"></app-edit-enrollment-dialog>
                        </template>                  
                      </v-list-tile-action>                      
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-btn dark flat class="red darken-3" @click="onDeleteTrial(item)">
                          <v-icon small dark class="text--lighten-1">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>                      
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs2 sm1 md1 ml-0 mr-0 mb-0 mt-4 justify-center>
        <v-card class="info" v-for="item in enrollments" v-bind:key="item.enrollmentId">
          <v-list class="listItems pa-0">
              <v-list-tile class="pb-2 pt-2 pl-2">
                  <v-menu bottom left v-if="userIsAuthenticated">
                    <v-btn icon slot="activator">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-btn dark flat class="red darken-3" @click="onDeleteEnrollment(item)">
                            <v-icon small dark class="text--lighten-1">delete</v-icon>
                          </v-btn>
                        </v-list-tile-action>                      
                      </v-list-tile>
                    </v-list>
                  </v-menu>         
              </v-list-tile>
          </v-list>          
        </v-card>      
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center class="mt-0">
      <v-flex xs12 class="text-xs-center">
        <v-btn align-center depressed class="mt-0 cyan--text text--darken-3 text-center" color="cyan lighten-5" dark :to="'/enrollment/new'">New Enrollment</v-btn>        
      </v-flex>      
    </v-layout>    	    	
  </v-container>
</template>

<script>
export default {
  computed: {
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    enrollment (index) {
      console.log('CURRENT ITEM: ' + JSON.stringify(this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId)))
      return this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId)
    },
    onDeleteEnrollment (enrollment) {
      console.log('Delete this: ' + JSON.stringify(enrollment))
      this.$store.dispatch('deleteEnrollmentData', enrollment)
      this.$router.push('/Trials/Enrollments')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Archive.vue?7bd4d008